"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
exports.useDocumentTitle = function (docTitle) {
    react_1.useEffect(function () {
        if (document && document.title !== undefined) {
            document.title = docTitle || "Mesa";
        }
    }, [docTitle]);
};
